import { Tooltip } from '@/app/components/overlays/tooltip';
import {
  PopoverOptions,
  type PopoverOptionsProps,
} from '@/app/components/shared/dealer/components/shared/filter-options/popover-options';

export interface PopoverOptionsDesktopProps
  extends Omit<PopoverOptionsProps, 'children'> {
  className?: string;
  isShow: boolean;
  children: React.ReactNode;
}

export const PopoverOptionsDesktop = ({
  className,
  isShow = false,
  children,
  ...props
}: PopoverOptionsDesktopProps) => {
  return (
    <Tooltip
      wrapperClassName="z-10 hidden xl:block"
      tooltipClassName="min-w-80"
      show={isShow}
      autoPlacement
      arrowClassName="hidden"
      autoClose={false}
      manualShow
      element={<PopoverOptions {...props} />}
    >
      {children}
    </Tooltip>
  );
};
